import React, { Fragment } from 'react';
import { FaCaretRight } from 'react-icons/fa';

const Progress = ({ step, activeStep, i }) => {
  return (
    <Fragment>
      {activeStep >= i ? (
        <div className="mr-1 lg:mr-3 text-gray-200 bg-cf-300 p-1 text-xs md:text-sm w-3 md:w-5 h-3 lg:h-5 flex items-center justify-center">
          {i + 1}
        </div>
      ) : (
        <div className="mr-1 lg:mr-3 text-gray-500 border p-1 text-xs md:text-sm w-3 md:w-5 h-3 lg:h-5 flex items-center justify-center">
          {i + 1}
        </div>
      )}

      <p className="text-xs md:text-sm lg:text-base">{step}</p>

      {activeStep >= i ? (
        <div className="mx-1 lg:mx-3 text-base lg:text-2xl">
          <FaCaretRight />
        </div>
      ) : (
        <div className="mx-1 lg:mx-3 text-base lg:text-2xl text-gray-200">
          <FaCaretRight />
        </div>
      )}
    </Fragment>
  );
};

export default Progress;
